import { Link } from "react-router-dom";
import { RotateCcw } from "lucide-react";

const FEELINGS = {
  calmer: ["😌", "Calmer", "That's your nervous system settling. You did that in one minute, and you can do it again any time."],
  same: ["🙂", "About the same", "That's okay. Some days need more than a minute. Even a small pause is practice that adds up."],
  tense: ["😣", "Still tense", "Thank you for being honest. Tension can take a while to ease, and you don't have to sort it out alone."],
};

export const CalmFeedback = ({ feel, onFeel, onAgain }) => {
  if (!feel) return (
    <div className="text-center" data-testid="calm-feedback">
      <p className="text-xl font-bold">How do you feel now?</p>
      <div className="flex flex-wrap justify-center gap-2 mt-4">
        {Object.entries(FEELINGS).map(([k, [e, l]]) => <button key={k} onClick={() => onFeel(k)} className="mm-chip !py-2.5 !px-4" data-testid={`calm-feel-${k}`}>{e} {l}</button>)}
      </div>
    </div>
  );
  return (
    <div className="mm-fade-up" data-testid="calm-reply">
      <p className="text-lg" data-testid="calm-reply-text">{FEELINGS[feel][2]}</p>
      {feel === "tense" && (
        <div className="mm-soft rounded-2xl p-4 mt-4 text-sm" data-testid="calm-tense-help">
          <Link to="/wellbeing-check" className="font-semibold text-mm-primary" data-testid="calm-wellbeing-link">Take the free 2-minute wellbeing check →</Link>
          <p className="mt-2">If you're struggling right now: call or text <a href="tel:988" className="font-semibold text-mm-primary">988</a> (US), text HOME to <a href="sms:741741" className="font-semibold text-mm-primary">741741</a>, or find a line near you at <a href="https://findahelpline.com" target="_blank" rel="noreferrer" className="font-semibold text-mm-primary">findahelpline.com</a>.</p>
        </div>
      )}
      <p className="text-mm-muted mt-5">Mindful Me has 100+ tools like this, plus daily check-ins and Mia, your calm companion.</p>
      <div className="flex flex-wrap gap-2 mt-4">
        <Link to="/pricing" className="mm-btn" data-testid="calm-see-pricing">See pricing</Link>
        <button onClick={onAgain} className="mm-btn-ghost" data-testid="calm-try-another"><RotateCcw size={16} />Try another</button>
        <Link to="/tools" className="mm-btn-ghost" data-testid="calm-explore-tools">Explore free calm tools</Link>
      </div>
    </div>
  );
};
